import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const SpecialInputLabelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	justify-content: space-between;
	width: 100%;
`;

export const SpecialInputWrapper = styled.div`
	width: 100%;
	max-width: ${CONFIG.inputs.maxWidth.default};
	color: ${CONFIG.colors.grey};
	font-family: ${CONFIG.fonts.regular};
	font-size: ${CONFIG.inputs.fontSize};
	padding: ${CONFIG.inputs.padding.default};

	border: ${(props) => {
		if (!props.value) {
			return CONFIG.inputs.border.default;
		} else {
			return CONFIG.inputs.border.filled;
		}
	}};
	border-radius: ${CONFIG.inputs.border.radius};
`;

export const SpecialInput = styled.input`
	width: ${(props) => {
		return props.width;
	}};
	max-width: ${CONFIG.inputs.maxWidth.default};
	color: ${CONFIG.inputs.color};
	font-family: ${CONFIG.inputs.fontFamily};
	font-size: ${CONFIG.inputs.fontSize};

	border: 0px;

	::placeholder {
		color: ${CONFIG.inputs.placeholder.color};
		font-family: ${CONFIG.inputs.placeholder.fontFamily};
		font-size: ${CONFIG.inputs.placeholder.fontSize};
	}
`;
